import { memo } from 'react';

import { CheckoutConfirmationResponseType } from 'src/models/Checkout/Confirmation';
import { CheckoutConfirmationTable } from 'src/pages/Checkout/components/common/Table';
import { useTHelper } from 'src/utils/i18n';
import { commonFormatCurrencyWithType } from 'src/utils/currency';

type Props = {
  model: CheckoutConfirmationResponseType['RegistrationLinesSubsection'];
};

export const CheckoutConfirmationRegistrationLines = memo<Props>(({ model }) => {
  const tHelper = useTHelper('checkout.confirmation.registrationLines');

  const teamsColumns = [
    { name: model.TeamTerminology.Singular || '' },
    model.ShowTeamGoalColumn && { name: tHelper('columns.goal') },
    { name: model.ContributionTerminology.Singular || '' },
    { name: tHelper('columns.price') },
    model.ShowTeamInvitesColumn && {
      name: tHelper('columns.invited', { plural: model.TeamMemberTerminology.Plural || '' }),
    },
  ];

  const teamMembersColumns = [
    { name: tHelper('columns.name', { singular: model.TeamMemberTerminology.Singular || '' }) },
    model.ShowTeamColumn && { name: model.TeamTerminology.Singular || '' },
    { name: model.ContributionTerminology.Singular || '' },
    { name: tHelper('columns.price') },
  ];

  return (
    <>
      {!!model.RegistrationTeamsLines.length && (
        <>
          <h2 className="section-header">{tHelper('title', { singular: model.TeamTerminology.Singular || '' })}</h2>

          <CheckoutConfirmationTable columns={teamsColumns} data={model.RegistrationTeamsLines}>
            {(item) => (
              <>
                <td>{item.Name}</td>
                {model.ShowTeamGoalColumn && <td>{item.Goal}</td>}
                <td>{item.RegistrationTitle}</td>
                <td>
                  {item.RegistrationPrice > 0
                    ? commonFormatCurrencyWithType(item.RegistrationPrice, model.CurrencyType)
                    : tHelper('columns.free')}
                </td>
                {model.ShowTeamInvitesColumn && <td>{item.InvitedMembers}</td>}
              </>
            )}
          </CheckoutConfirmationTable>
        </>
      )}

      {!!model.RegistrationTeamMembersLines.length && (
        <>
          <h2 className="section-header">
            {tHelper('title', { singular: model.TeamMemberTerminology.Singular || '' })}
          </h2>

          <CheckoutConfirmationTable columns={teamMembersColumns} data={model.RegistrationTeamMembersLines}>
            {(item) => (
              <>
                <td>{item.Name}</td>
                {model.ShowTeamColumn && <td>{item.TeamName}</td>}
                <td>{item.RegistrationTitle}</td>
                <td>
                  {item.RegistrationPrice > 0
                    ? commonFormatCurrencyWithType(item.RegistrationPrice, model.CurrencyType)
                    : tHelper('columns.free')}
                </td>
              </>
            )}
          </CheckoutConfirmationTable>
        </>
      )}
    </>
  );
});
